import { createContext, useContext } from "react";
import { GENERIC_LANDING_CONFIG } from "../config/openDoorEvents";

const LandingConfigContext = createContext(null);

export function LandingConfigProvider({ children, config = GENERIC_LANDING_CONFIG }) {
  return <LandingConfigContext.Provider value={config}>{children}</LandingConfigContext.Provider>;
}

export function useLandingConfig() {
  const ctx = useContext(LandingConfigContext);
  if (!ctx) {
    return GENERIC_LANDING_CONFIG;
  }
  return ctx;
}
